/**
 * Per-bar delta approximation and session-cumulative CVD.
 * delta = v*(2c-h-l)/(h-l), or sign(c-prevClose)*v when h===l.
 */

function px(bar, field) {
  const n = typeof bar?.[field] === 'number' ? bar[field] : parseFloat(bar?.[field]);
  return Number.isFinite(n) ? n : null;
}

export function barDeltaValue(bar, prevClose) {
  const h = px(bar, 'high');
  const l = px(bar, 'low');
  const c = px(bar, 'close');
  const v = Number(bar?.volume) || 0;
  if (![h, l, c].every(Number.isFinite)) return 0;
  if (h === l) {
    if (!Number.isFinite(prevClose)) return 0;
    return Math.sign(c - prevClose) * v;
  }
  return (v * (2 * c - h - l)) / (h - l);
}

/**
 * @param {Array} bars
 * @param {Array} sessionInfo - from buildSessionIndex(bars)
 * @returns {{ delta: number[], cvd: number[] }}
 */
export function barDeltaFromBars(bars, sessionInfo) {
  const n = bars?.length || 0;
  const delta = new Array(n).fill(0);
  const cvd = new Array(n).fill(0);
  let lastDateKey = null;
  let running = 0;
  let prevClose = null;
  for (let i = 0; i < n; i++) {
    const info = sessionInfo?.[i];
    if (!info?.isRth) {
      delta[i] = 0;
      cvd[i] = running;
      continue;
    }
    if (info.dateKey !== lastDateKey) {
      lastDateKey = info.dateKey;
      running = 0;
      prevClose = null;
    }
    const d = barDeltaValue(bars[i], prevClose);
    delta[i] = d;
    running += d;
    cvd[i] = running;
    prevClose = px(bars[i], 'close');
  }
  return { delta, cvd };
}
